export const getServiceUrl = () => {
  const { protocol, hostname } = window.location;

  if (hostname === "localhost") {
    return `${protocol}//${hostname}:8000`;
  }

  return `${protocol}//${hostname}`;
};

export const SERVICE_URL = getServiceUrl();
export const OPEN_DATE = new Date("2025-09-03T12:00:00+09:00");
